import React from 'react';
import styled from 'styled-components';
import placeholders from './placeholders';
var Wrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "Placeholder__Wrapper",
  componentId: "dh2wmw-0"
})(["width:", ";"], function (props) {
  return props.type === 'rect' || props.type === 'custom' ? 'auto' : '100%';
});
var Placeholder = function Placeholder(props) {
  var type = props.type,
    className = props.className;
  var Component = placeholders[type];
  return /*#__PURE__*/React.createElement(Wrapper, {
    type: type,
    className: className
  }, /*#__PURE__*/React.createElement(Component, props));
};
Placeholder.displayName = 'Placeholder';
export default Placeholder;